import { useCallback, useState } from 'react'

// useState that is kept in sessionStorage, so values (e.g. list filters) survive
// leaving the page and coming back with browser back/forward.
// If `key` changes, the value for the new key is loaded.
function readStored(key, initialValue) {
    try {
        const stored = sessionStorage.getItem(key)
        return stored === null ? initialValue : JSON.parse(stored)
    } catch {
        return initialValue
    }
}

export default function usePersistedState(key, initialValue) {
    const [state, setState] = useState(() => ({ key, value: readStored(key, initialValue) }))

    let value = state.value
    if (state.key !== key) {
        value = readStored(key, initialValue)
        setState({ key, value })
    }

    const setValue = useCallback((next) => {
        setState((prev) => {
            const resolved = typeof next === 'function' ? next(prev.value) : next
            try {
                sessionStorage.setItem(key, JSON.stringify(resolved ?? null))
            } catch { }
            return { key, value: resolved }
        })
    }, [key])

    return [value, setValue]
}
